<template>
  <div class="billing">
    <h2>Информация о занятиях</h2>
    <div class="billing__body">
      <ul class="uk-grid-match" uk-grid>
        <li class="uk-width-2-5@s">
          <div>
            <div class="billing__status">
              <div class="billing__header">Статус</div>
              <info @onBuyPacket="modalAction" v-if="subscribe" :subscribe="subscribe" :remainder="remainder"></info>
            </div>
            <div class="billing__help">
              <div class="billing__header">Помощь</div>
              <help @onBuyPacket="modalAction"></help>
            </div>
          </div>
        </li>
        <li class="uk-width-3-5@s">
          <div>
            <div class="billing__header">Мои занятия</div>
            <lessons :items="lessons"></lessons>
          </div>
        </li>
      </ul>
    </div>

    <modal :showsettings="showsettings">
      <template v-slot:header>Жопа</template>
      <template v-slot:body>
        <component :is="current_block" v-if="current_block"></component>
      </template>
    </modal>

  </div>
</template>

<script>
import http from "../components/classes/http";
import lessons from "./components/lessons";
import info from "./components/info"
import help from "./components/help"
import modal from "./components/modal"
import { modal_mix } from "./../components/mixins/modal"
import { mapState } from 'vuex';

export default {
  name: "billing",
  provide() {
    return {
      'http': http
    }
  },
  components: {
    lessons,
    info,
    help,
    modal,
    buy_packet: require('./components/buy_packet').default,
    freeze_order: require('./components/freeze_order').default,
    workoff_order: require('./components/workoff_order').default,
  },
  mixins: [modal_mix],
  data() {
    return {
      current_block: '',
    }
  },
  computed: {
    remainder() {
      return _.filter(this.lessons, e => e.is_active).length;
    },
    ...mapState('billing', ['lessons', 'subscribe'])
  },
  props: {
    obuser: ''
  },
  methods: {
    changeUser() {
      if (this.obuser) {
        this.$store.commit('setUser', this.obuser);
      }
    },
    modalAction(target) {
      this.current_block = target;
      this.setShowsettings();
    },
    async getUserInfo() {
      let info = await http.post('onGetBillingInfo', { 'user_id': this.obuser.id }).then(res => res.data);
      this.$store.commit('billing/add_billing_info', info);
    }
  },
  async mounted() {
    await this.getUserInfo();
    this.changeUser();
  }
}
</script>